module.exports = __webpack_public_path__ + "img/showHow1.5e37f10b.png";